export const services = {
  // Airport Transfers
  airportTransfers: 'Transferências Aeroporto',
  airportTransfersDesc: 'Serviço de transporte premium de e para todos os aeroportos do Marrocos e do Canadá.',
  airportTransfersFeatures: [
    'Pontualidade garantida',
    'Veículos climatizados',
    'Motoristas profissionais'
  ],
  airportTransfersDetailDesc: 'Nosso serviço de transferência aeroportuária garante uma viagem confortável e sem estresse. Nossos motoristas profissionais recebem você com uma placa nominal e cuidam de suas bagagens.',
  airportTransfersIncluded: [
    'Rastreamento de voo em tempo real',
    'Veículos Mercedes e BMW recentes',
    'Água e refrescos a bordo',
    'WiFi gratuito em todos os veículos',
    'Serviço de concierge',
    'Assistência 24h/24'
  ],
  airports: ['Mohammed V - Casablanca', 'Marrakech Menara', 'Agadir Al Massira', 'Fès Saïs', 'Montreal-Trudeau', 'Toronto Pearson'],
  
  // Tourist Circuits
  touristCircuits: 'Circuitos Turísticos',
  touristCircuitsDesc: 'Explore as maravilhas do Marrocos com nossos circuitos personalizados e guias especializados.',
  touristCircuitsFeatures: [
    'Itinerários sob medida',
    'Guias multilíngues',
    'Descobertas autênticas'
  ],
  touristCircuitsDetailDesc: 'Descubra o Marrocos autêntico com nossos circuitos sob medida. Da medina de Fez às dunas de Merzouga, cada itinerário é projetado para oferecer uma experiência inesquecível.',
  touristCircuitsIncluded: [
    'Guia certificado multilíngue',
    'Veículo 4x4 climatizado',
    'Hospedagem em riads e acampamentos berberes',
    'Refeições tradicionais incluídas',
    'Atividades culturais',
    'Fotos profissionais'
  ],
  destinations: ['Deserto de Merzouga', 'Vale do Dadès', 'Aït Benhaddou', 'Chefchaouen', 'Essaouira', 'Montanhas Atlas'],
  
  // Crew Transport
  crewTransport: 'Serviço de transporte para tripulações aéreas',
  crewTransportDesc: 'Serviço especializado para tripulações de cabine (cabin crew) e pessoal de voo.',
  crewTransportFeatures: [
    'Transporte cabin crew',
    'Horários flexíveis',
    'Serviço profissional'
  ],
  crewTransportDetailDesc: 'Nosso serviço especializado é destinado a tripulações de cabine (cabin crew) e pessoal de voo. Compreendemos as restrições de horário e as necessidades específicas do setor aéreo.',
  crewTransportIncluded: [
    'Transporte adaptado aos horários de voo',
    'Veículos confortáveis para descanso',
    'Serviço 24h/24 para todos os horários',
    'Motoristas treinados para necessidades cabin crew',
    'Rastreamento de horários de voo em tempo real',
    'Tarifas preferenciais para companhias aéreas'
  ],
  occasions: ['Tripulações em escala', 'Pessoal de voo', 'Cabin crew em descanso', 'Transferências hotel-aeroporto', 'Serviços companhias aéreas'],
  
  // Day Excursions
  dayExcursions: 'Excursões de Um Dia',
  dayExcursionsDesc: 'Descubra os locais emblemáticos durante excursões de um dia inesquecíveis.',
  dayExcursionsFeatures: [
    'Partida matinal',
    'Locais imperdíveis',
    'Retorno confortável'
  ],
  dayExcursionsDetailDesc: 'Perfeito para descobrir os tesouros do Marrocos em um dia. Nossas excursões combinam locais históricos, paisagens naturais e experiências culturais autênticas.',
  dayExcursionsIncluded: [
    'Transporte ida e volta',
    'Guia local experiente',
    'Almoço tradicional',
    'Entradas para locais turísticos',
    'Pausa para chá de menta',
    'Tempo livre para compras'
  ],
  dayDestinations: ['Cascatas de Ouzoud', 'Vale de Ourika', 'Essaouira', 'Aït Benhaddou', 'Imlil', 'Ouarzazate'],
  
  // Chauffeur Service
  chauffeurService: 'Aluguel com Motorista',
  chauffeurServiceDesc: 'Veículos premium com motoristas experientes para seus deslocamentos livres.',
  chauffeurServiceFeatures: [
    'Flexibilidade total',
    'Tarifas transparentes',
    'Disponibilidade 24h/7d'
  ],
  chauffeurServiceDetailDesc: 'Alugue um veículo com motorista para total liberdade em seus deslocamentos. Ideal para estadias prolongadas ou viagens de negócios.',
  chauffeurServiceIncluded: [
    'Veículo recente e mantido',
    'Motorista profissional bilíngue',
    'Combustível incluído',
    'Seguro contra todos os riscos',
    'Assistência rodoviária 24h/24',
    'Limpeza diária do veículo'
  ],
  vehicles: ['Sedãs confortáveis', 'SUV 7 lugares', 'Minibus 15 lugares', 'Veículos de luxo'],
  
  // Canada Services
  canadaServices: 'Serviços Canadá',
  canadaServicesDesc: 'Extensão de nossos serviços premium no Canadá para suas viagens norte-americanas.',
  canadaServicesFeatures: [
    'Montreal e Toronto',
    'Circuitos de inverno',
    'Experiência canadense'
  ],
  canadaServicesDetailDesc: 'Descubra o Canadá com o mesmo nível de serviço premium. Nossos parceiros locais oferecem uma experiência autêntica nas mais belas cidades canadenses.',
  canadaServicesIncluded: [
    'Veículos adaptados ao clima canadense',
    'Guias francófonos nativos',
    'Circuitos urbanos e natureza',
    'Experiências de inverno únicas',
    'Hospedagem em hotéis boutique',
    'Especialidades culinárias locais'
  ],
  cities: ['Montreal', 'Toronto', 'Quebec', 'Ottawa', 'Cataratas do Niágara', 'Mont-Tremblant']
};